module.exports = __webpack_public_path__ + "static/media/armadillo-booking-5.36f67793.png";